import { useEffect } from 'react';

const BodyOverflowHiddenPositionFixed = () => {
  useEffect(() => {
    /*
     * ios에서 body의 넘침으로 인해 window 스크롤이 발생함을 방지하기 위하여 body의 overflow를 hidden 으로 설정합니다.
     * unmount 될때는 기본값인 visible로 되돌려 놓습니다.
     * 또한 Android, iOS의 AddressBar위치에 따라 레이아웃이 fit되지 않아 body에게 fixed 포지션을 부여합니다.
     */
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
    };
  });
  return null;
};

export default BodyOverflowHiddenPositionFixed;
